import { useMutation } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';
import { ENDPOINTS } from '../constants/endpoints';

async function resendVerification(email: string) {
  const response = await apiFetch(ENDPOINTS.RESEND_VERIFICATION, {
    method: 'POST',
    body: JSON.stringify({ email }),
    isPublic: true,
  });

  if (response.ok) return;

  const body = await response.json().catch(() => ({}));
  throw new Error(body.message ?? 'Could not send verification email.');
}

export const useResendVerification = () => {
  return useMutation({ mutationFn: resendVerification });
};
